import { render, staticRenderFns } from "./BarRoi.vue?vue&type=template&id=12a9c0ef&"
import script from "./BarRoi.vue?vue&type=script&lang=js&"
export * from "./BarRoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports